const compareBuild = require('./compare-build')
const sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose))
module.exports = sort



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/sort.js
// module id = 2459
// module chunks = 0